
import { computed, defineComponent, reactive } from 'vue';
import draggable from 'vuedraggable';
import { Modal } from 'ant-design-vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import Icone from '@/core/components/Icone.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { IProdutoImagem } from '@/models/Entidades/Cadastros/Produtos/IProduto';
import { IRetornoArquivo } from '@/core/models/IRetornoArquivo';
import { EStatusRetornoRequisicao } from '@/core/models/IRetornoRequisicao';
import ServicoProduto from '@/servicos/Cadastros/Produtos/ServicoProduto';

export default defineComponent({
  name: 'ProdutoImagens',
  props: {
    imagens: {
      type: Array as () => IProdutoImagem[],
      required: true,
    },
    empresas: {
      type: Array as () => number[],
      required: true,
    },
  },
  components: {
    Icone,
    draggable,
    MensagemSemDados,
  },
  emits: ['update:imagens'],
  setup(props, { emit }) {
    const servicoProduto = new ServicoProduto();
    const state = reactive({
      indexPreview: 1,
      imagemPrincipal: false,
      enviandoImagens: false,
      excluindoImagens: false,
      imagemBranco: 'data:image/png;base64,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',
    });

    function obtemImagensBranco():number {
      let imagensEmBranco = 14;

      if (UtilitarioGeral.validaLista(props.imagens)) {
        if (props.imagens.length < imagensEmBranco) {
          const imagensExistens = props.imagens.filter((c) => c.principal === false);
          if (UtilitarioGeral.validaLista(imagensExistens)) {
            imagensEmBranco -= imagensExistens.length;
          }
        } else {
          imagensEmBranco = 0;
        }
      }

      return imagensEmBranco;
    }

    const computedImagens = computed({
      get: () => props.imagens,
      set: (valor: IProdutoImagem[]) => {
        emit('update:imagens', valor);
      },
    });

    const computedImagensBranco = computed(() => obtemImagensBranco());

    function defineImagemPrincipal(imagem:string) {
      if (UtilitarioGeral.validaLista(computedImagens.value)) {
        const indexPrincipal = computedImagens.value.findIndex((c) => c.imagem === imagem);

        for (let i = 0; i < computedImagens.value.length; (i += 1)) {
          computedImagens.value[i].principal = false;
        }

        if (indexPrincipal >= 0) {
          computedImagens.value[indexPrincipal].principal = true;
        }
      }
      state.indexPreview += 1;
    }

    async function removerImagem(produtoImagem: IProdutoImagem) {
      state.excluindoImagens = true;
      const retornoArquivo = await servicoProduto.removerImagem(produtoImagem.codigo, produtoImagem.imagem);
      if (retornoArquivo.status === EStatusRetornoRequisicao.Sucesso || retornoArquivo.status === EStatusRetornoRequisicao.Alerta) {
        const index = computedImagens.value.findIndex((c) => c.imagem === produtoImagem.imagem);
        if (index !== -1) {
          computedImagens.value.splice(index, 1);
        }
      }
      state.indexPreview += 1;
      state.excluindoImagens = false;
    }

    function selecionarImagemUpload() {
      const elemento = document.getElementById('selecionarImagemProduto');
      if (elemento !== null) {
        elemento.click();
      }
    }
    function confirmaExclusao(produtoImagem: IProdutoImagem) {
      Modal.confirm({
        title: 'Você deseja remover a imagem:',
        content: `${produtoImagem.imagem} ?`,
        okText: 'Sim',
        okType: 'danger',
        cancelText: 'Não',
        autoFocusButton: null,
        onOk: () => { removerImagem(produtoImagem); },
      });
    }
    function novaImagem(retorno: IRetornoArquivo) {
      const produtoImagem:IProdutoImagem = {} as IProdutoImagem;
      produtoImagem.codigo = 0;
      produtoImagem.codigoProdutoDefinicao = 0;
      produtoImagem.imagem = retorno.linkArquivo;
      produtoImagem.principal = state.imagemPrincipal;
      computedImagens.value.push(produtoImagem);

      if (state.imagemPrincipal) {
        defineImagemPrincipal(retorno.linkArquivo);
      }
      state.imagemPrincipal = false;
    }
    async function enviarImagens(event:any) {
      state.enviandoImagens = true;
      const retornoImagens = await servicoProduto.enviarImagens(event.target.files, props.empresas[0]);
      retornoImagens.forEach((retorno) => {
        if (retorno.status) {
          novaImagem(retorno);
        }
      });

      state.enviandoImagens = false;
    }

    async function dropImagem(event:any) {
      state.enviandoImagens = true;
      const retornoImagens = await servicoProduto.enviarImagens(event.dataTransfer.files, props.empresas[0]);
      retornoImagens.forEach((retorno) => {
        if (retorno.status) {
          novaImagem(retorno);
        }
      });
      state.enviandoImagens = false;
    }

    function obtemImagemPrincipal():IProdutoImagem {
      let produtoImagem:IProdutoImagem = {} as IProdutoImagem;
      produtoImagem.codigo = 0;
      produtoImagem.imagem = '';
      produtoImagem.principal = false;
      if (UtilitarioGeral.validaLista(computedImagens.value)) {
        const imagemExistente = computedImagens.value.find((c) => c.principal === true);
        if (imagemExistente !== undefined) {
          produtoImagem = imagemExistente;
        }
      }
      return produtoImagem;
    }
    return {
      props,
      computedImagens,
      computedImagensBranco,
      state,
      dropImagem,
      enviarImagens,
      confirmaExclusao,
      selecionarImagemUpload,
      defineImagemPrincipal,
      obtemImagemPrincipal,
      obtemImagensBranco,
    };
  },
});
